import { useEffect } from "react";

const BASE = "SterlingNest | Practical Tally, GST & TDS Training Institute";

export const useTitle = (title) => {
  useEffect(() => {
    document.title = title ? `${title} | SterlingNest` : BASE;
  }, [title]);
};
